/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
==========================================================================================*/

import bcrypt from "bcryptjs";

import axios from "@/axios.js";
import vm from "../../main.js";

import pouch from '@/db/pouch';

export default {
  addUser({
    commit
  }, user) {
    return new Promise(async (resolve, reject) => {
      try {
        user.c = bcrypt.hashSync(user.c, 8);
        return await pouch.en(user).then(async (eu) => {
          return await pouch.f({
            selector: {
              f: eu.f,
              z: 0
            }
          }, true, false).then(async (sr) => {
            if (sr.hasOwnProperty('f')) {
              return reject('A user exists with this username. Try again with a different username.');
            } else {
              return await pouch.c(eu, true).then((cu) => {
                if (cu.ok) {
                  return resolve('User successfully registered');
                }
                return reject(cu.message);
              })
            }
          })
        });
      } catch (e) {
        return reject(e);
      }
    });
  },

  // fetchUser(context, userId) {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .get(`/api/user-management/users/${userId}`)
  //       .then((response) => {
  //         resolve(response);
  //       })
  //       .catch((error) => {
  //         reject(error);
  //       });
  //   });
  // },
  removeRecord({
    commit
  }, userId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/user-management/users/${userId}`)
        .then((response) => {
          commit("REMOVE_RECORD", userId);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};